module.exports = __webpack_public_path__ + "media/images/ic_fav-70afddf258a98e7f731d3ff9774e95e3.svg";